/**
 * Apartment number has simple default config in address template.  However if
 * more complicated handling is required, then it does not make sense to
 * further complicate the address template but create special config just for
 * apartment number.
 */
import { Address } from 'api/api';

interface ApartmentNumberConfig {
  separator: string;
}

const apartmentNumberConfig: { [key: string]: ApartmentNumberConfig } = {
  FI: {
    separator: ' ',
  },
  PL: {
    separator: '/',
  },
};

export function getApartmentNumberConfig(country: string) {
  return apartmentNumberConfig[country];
}

export function formatApartmentNumber(address: Address, country: string): Partial<Address> {
  const apartmentNumberConfig = getApartmentNumberConfig(country);

  const { street_number, apartment_number } = address;

  if (!apartmentNumberConfig || !apartment_number || !street_number) {
    return address;
  }

  return {
    ...address,
    street_number: `${street_number}${apartmentNumberConfig.separator}${apartment_number}`,
    apartment_number: undefined, // remove apartment_number from further processing
  };
}
